import api from 'api';
import { UserTypes } from 'enums/types';

import { defaultPagination } from './general';

type GetUserType = {id?: number | string}

export const listUsers = async (params) => api().get('/users', { params: { ...defaultPagination, ...params } });

export const getUser = async ({ id }:GetUserType) => api().get(id ? `/users/${id}` : '/user');

export const importUser = async ({ data }) => api().post('import/users', data, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export const createUser = async ({ data }) => api().post('signup', { ...data, type: UserTypes.Manager });

export const createSuperUser = async ({ data }) => api().post('signup', { ...data, isSuperUser: true });

export const updateUser = async ({ id, data }) => api().put(`users/${id}`, data);

export const updateAvatarUrl = async ({ id, avatarUrl }) => api().put(`users/avatar_url/${id}`, { avatarUrl });
